"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var end2end_1 = require("@hudled/end2end");
var constants_1 = require("containers/TableMaker/constants");
var populated_1 = require("utils/selectors/populated");
var Vendor_1 = __importDefault(require("../Recharges/CellComponents/Vendor"));
var UploadCSVButton_1 = __importDefault(require("./CellComponents/UploadCSVButton"));
var XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD;
var tableConf = {
    headersMap: {
        'rechVendor.name': 'Vendor',
        number: 'Invoice Number',
    },
    config: {
        noFooter: true,
        selector: populated_1.selectPopRechargeImports,
        defaultSort: { key: 'date', order: -1 },
    },
    cells: [
        {
            field: 'rechVendor',
            cell: { width: LG },
            truncate: {},
            renderComponent: Vendor_1.default,
        },
        { field: 'number', cell: { width: XL }, truncate: {} },
        { field: 'date', cell: { width: MD }, renderField: end2end_1.getDateNice },
        { key: 'uploadCSV', cell: { width: LG }, renderComponent: UploadCSVButton_1.default },
    ],
};
exports.default = tableConf;
